"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Header;

var _react = _interopRequireDefault(require("react"));

var _chevronLeft = _interopRequireDefault(require("@remote-com/norma/icons/chevron-left.svg"));

var _chevronRight = _interopRequireDefault(require("@remote-com/norma/icons/chevron-right.svg"));

var _dates = require("../../../../../constants/dates");

var _Header = require("./Header.styled");

var __jsx = _react["default"].createElement;

function getYear(date) {
  return new Date(date).getFullYear();
}

function getMonth(date) {
  return new Date(date).getMonth();
}

function Header(_ref) {
  var changeMonth = _ref.changeMonth,
      changeYear = _ref.changeYear,
      date = _ref.date,
      decreaseMonth = _ref.decreaseMonth,
      increaseMonth = _ref.increaseMonth,
      nextMonthButtonDisabled = _ref.nextMonthButtonDisabled,
      prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate;

  var months = _dates.monthOptions.map(function (month) {
    return month.label;
  });

  var handleChangeMonth = function handleChangeMonth(_ref2) {
    var value = _ref2.target.value;
    changeMonth(months.indexOf(value));
  };

  var handleChangeYear = function handleChangeYear(_ref3) {
    var target = _ref3.target;
    var updatedYear = target.value;

    if (updatedYear.length > 1) {
      // NOTE: Number inputs accept leading zeroes. To make for a
      // better user experience, we're trimming all leading zeroes
      // from the value string.
      updatedYear = updatedYear.replace(/^0+/, ''); // NOTE: We are not expecting years with more than 4 digits.
      // Since number inputs don't accept the `maxLength` attribute,
      // we're limiting the length here.

      updatedYear = updatedYear.slice(0, 4);
      target.value = updatedYear;
    }

    changeYear(updatedYear);
  };

  var currentYear = date.getFullYear();
  var minYear = minDate === null || minDate === void 0 ? void 0 : minDate.getFullYear();
  var maxYear = maxDate === null || maxDate === void 0 ? void 0 : maxDate.getFullYear();
  var minMonth = minDate === null || minDate === void 0 ? void 0 : minDate.getMonth();
  var maxMonth = maxDate === null || maxDate === void 0 ? void 0 : maxDate.getMonth();
  return __jsx(_Header.Wrapper, null, __jsx(_Header.DateNavigation, null, __jsx(_Header.MonthSelect, {
    "aria-label": "Month",
    onChange: handleChangeMonth,
    value: months[getMonth(date)],
    "data-testid": "datepicker-select-month"
  }, months.map(function (option) {
    var isDisabled = currentYear === minYear && months.indexOf(option) < minMonth || currentYear === maxYear && months.indexOf(option) > maxMonth || currentYear < minYear || currentYear > maxYear;
    return __jsx("option", {
      key: option,
      value: option,
      disabled: isDisabled
    }, option);
  })), __jsx(_Header.YearInput, {
    "aria-label": "Year",
    onChange: handleChangeYear,
    type: "number",
    value: getYear(date),
    "data-testid": "datepicker-input-year",
    min: minYear,
    max: maxYear
  })), __jsx(_Header.MonthsNavigation, null, __jsx(_Header.PrevMonthButton, {
    "aria-label": "Previous month",
    disabled: prevMonthButtonDisabled,
    onClick: decreaseMonth,
    type: "button",
    "data-testid": "datepicker-button-month-prev"
  }, __jsx(_Header.Icon, {
    as: _chevronLeft["default"]
  })), __jsx(_Header.NextMonthButton, {
    "aria-label": "Next month",
    disabled: nextMonthButtonDisabled,
    onClick: increaseMonth,
    type: "button",
    "data-testid": "datepicker-button-month-next"
  }, __jsx(_Header.Icon, {
    as: _chevronRight["default"]
  }))));
}